const ENMatrizBcg = {
	"Ao menos um Item BCG deve ser informado": "At least one BCG Item must be informed",
	"Abacaxi": "Pineapple",
	"Crescimento de Mercado": "Market Growth",
	"Data inicio inválida": "Invalid start date",
	"Data fim inválida": "Invalid end date",
	"Dúvida": "Doubt",
	"Estrela": "Star",
	"Erro ao buscar dados do gráfico": "Error fetching chart data",
	"Erro ao carregar as Análises Matriz BCG": "Error loading BCG Matrix Analyzes",
	"Erro ao carregar Matriz BCG": "Error loading BCG Matrix",
	"Itens BCG": "BCG Items",
	"Itens BCG não podem ser repetidos": "BCG items cannot be repeated",
	"Nenhum item BCG adicionado": "No BCG items added",
	"Nenhuma Análise Matriz BCG selecionada": "No BCG Matrix Analysis selected",
	"Matriz BCG": "BCG Matrix",
	"Relativo": "Relative",
	"Participação Relativa de Mercado": "Relative Market Share",
	"Vaca Leiteira": "Milky Cow"
};


export default ENMatrizBcg;
